import { render, staticRenderFns } from "./sidebar2.vue?vue&type=template&id=7f5c6e36&scoped=true&"
import script from "./sidebar2.vue?vue&type=script&lang=js&"
export * from "./sidebar2.vue?vue&type=script&lang=js&"
import style0 from "./sidebar2.vue?vue&type=style&index=0&id=7f5c6e36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5c6e36",
  null
  
)

export default component.exports